// src/components/mre-banner/banner.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment UILinkActionFragment on UILinkAction {\n    resource {\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n    target\n    useRelativePath\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonFragment on EGDSButton {\n    accessibility\n    action {\n      ...UILinkActionFragment\n    }\n    disabled\n    primary\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment ActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    resource {\n      value\n    }\n    target\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      ...ActionFragment\n    }\n    size\n    text\n  }\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    weight\n    theme\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSStandardLinkFragment\n  }\n  ", "\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment MreBannerViewFragment on MREContents {\n    image {\n      description\n      url\n    }\n    heading {\n      ...EGDSStylizedTextFragment\n    }\n    body {\n      ...EGDSStylizedTextFragment\n    }\n    inLineLink {\n      ...EGDSStandardLinkFragment\n    }\n    button {\n      ...EGDSButtonFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  query MREBannerQuery($context: ContextInput!, $lob: String!, $pageType: String!, $preview: Boolean, $requestDate: String) {\n    mreQuery(context: $context, lob: $lob, pageType: $pageType, preview: $preview, requestDate: $requestDate) {\n      body {\n        ...EGDSStylizedTextFragment\n      }\n      button {\n        ...EGDSButtonFragment\n      }\n      heading {\n        ...EGDSStylizedTextFragment\n      }\n      image {\n        description\n        url\n      }\n      inLineLink {\n        ...EGDSStandardLinkFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment MemberMessageIllustrationFragment on Illustration {\n    description\n    id\n    link: url\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment MemberMessageGraphicFragment on UIGraphic {\n    ...MemberMessageIllustrationFragment\n  }\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment MemberMessageLinkFragment on EGDSStandardLink {\n    text\n    action {\n      resource {\n        value\n      }\n      target\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment MemberMessageTextFragment on EGDSStylizedText {\n    text\n  }\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  query MemberMessagesQuery(\n    $context: ContextInput!\n    $lineOfBusiness: String!\n    $pageType: String!\n    $packageType: String\n    $preview: Boolean\n    $requestDate: String\n  ) {\n    memberMessageCards(\n      context: $context\n      lineOfBusiness: $lineOfBusiness\n      pageType: $pageType\n      packageType: $packageType\n      preview: $preview\n      requestDate: $requestDate\n    ) {\n      heading {\n        ...MemberMessageTextFragment\n      }\n      subHeading {\n        ...MemberMessageTextFragment\n      }\n      graphic {\n        ...MemberMessageGraphicFragment\n      }\n      links {\n        ...MemberMessageLinkFragment\n      }\n      contentId\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
import React6 from "react";
import { gql as gql9, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// ../internal/src/components/egds-button/egds-button.tsx
import React from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/common/client-side-analytics.ts
import { gql } from "@apollo/client";
var clientSideAnalyticsFragment = gql(_templateObject());
// ../internal/src/components/ui-link-action/lodging-ui-link-action.ts
import { gql as gql2 } from "@apollo/client";
var _obj;
// ../internal/src/components/common/uitk-link-target-mapper.tsx
var UILinkTargetMap = (_obj = {}, _define_property(_obj, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj, "INTERNAL" /* INTERNAL */, "_self"), _obj);
// ../internal/src/components/ui-link-action/lodging-ui-link-action.ts
var fragment = gql2(_templateObject1());
var getUILinkActionPath = function (action) {
  if (action.resource.__typename !== "HttpURI") {
    return null;
  }
  return action.useRelativePath ? action.resource.relativePath : action.resource.value;
};
var getUILinkActionTarget = function (action) {
  return UILinkTargetMap[action.target];
};
// ../internal/src/components/egds-button/egds-button.tsx
var fragment2 = gql3(_templateObject2(), fragment, clientSideAnalyticsFragment);
var deriveLinkProps = function (action) {
  if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
    return {};
  }
  var path = getUILinkActionPath(action);
  if (!path) {
    return {};
  }
  return {
    href: path,
    target: getUILinkActionTarget(action),
    tag: "a"
  };
};
var buttonComponents = {
  UIPrimaryButton: EGDSPrimaryButton,
  UISecondaryButton: EGDSSecondaryButton,
  UITertiaryButton: EGDSTertiaryButton
};
var EGDSButton = function (_param) {
  var onClick = _param.onClick,
    _param_data = _param.data,
    __typename = _param_data.__typename,
    accessibility = _param_data.accessibility,
    analytics = _param_data.analytics,
    disabled = _param_data.disabled,
    primary = _param_data.primary,
    action = _param_data.action,
    dataStid = _param.dataStid,
    props = _object_without_properties(_param, ["onClick", "data", "dataStid"]);
  var linkProps = deriveLinkProps(action);
  var track = useClickTracker();
  var handleClick = React.useCallback(function (event) {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName;
      track(referrerId, linkName);
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  }, [analytics, onClick, track]);
  var buttonProps = _object_spread({
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
    disabled: disabled,
    onClick: handleClick
  }, disabled ? {} : linkProps, props);
  var Button = buttonComponents[__typename];
  if (Button) {
    return /* @__PURE__ */React.createElement(Button, _object_spread_props(_object_spread({}, buttonProps), {
      "data-stid": dataStid
    }), primary);
  }
  return null;
};
EGDSButton.fragment = fragment2;
EGDSButton.displayName = "EGDSButton";
// ../internal/src/components/egds-text/egds-text.tsx
import React4 from "react";
import { gql as gql7 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-standard-link.tsx
import React2 from "react";
import { gql as gql5 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
var _obj1;
// ../internal/src/components/common/link-map.tsx
var linkSizeMapper = (_obj1 = {}, _define_property(_obj1, "SMALL" /* SMALL */, "small"), _define_property(_obj1, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj1, "LARGE" /* LARGE */, "large"), _obj1);
var _obj2;
var UILinkTargetMap2 = (_obj2 = {}, _define_property(_obj2, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj2, "INTERNAL" /* INTERNAL */, "_self"), _obj2);
// ../internal/src/components/egds-text/__private/link-action.tsx
import { gql as gql4 } from "@apollo/client";
var UILinkActionFragment = gql4(_templateObject3());
// ../internal/src/components/egds-text/egds-standard-link.tsx
var fragment3 = gql5(_templateObject4(), UILinkActionFragment);
var EGDSStandardLink = function (param) {
  var className = param.className,
    inline = param.inline,
    _param_data = param.data,
    _param_data_action = _param_data.action,
    analytics = _param_data_action.analytics,
    resource = _param_data_action.resource,
    target = _param_data_action.target,
    accessibility = _param_data_action.accessibility,
    size = _param_data.size,
    text = _param_data.text;
  var clickTracker = useClickTracker2();
  var onClick = React2.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  return /* @__PURE__ */React2.createElement(UitkLink, {
    className: className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    inline: inline
  }, /* @__PURE__ */React2.createElement("a", {
    href: resource.value,
    target: UILinkTargetMap2[target]
  }, text, accessibility && /* @__PURE__ */React2.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.fragment = fragment3;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React3 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkText } from "uitk-react-text";
var _obj3;
// ../internal/src/components/common/text-utils.tsx
var textThemeMapper = (_obj3 = {}, _define_property(_obj3, "EMPHASIS" /* EMPHASIS */, "emphasis"), _define_property(_obj3, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj3, "INVERSE" /* INVERSE */, "inverse"), _define_property(_obj3, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj3, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj3, "PRIMARY" /* PRIMARY */, "emphasis"), _define_property(_obj3, "SECONDARY" /* SECONDARY */, "default"), _obj3);
var _obj4;
var textWeightMapper = (_obj4 = {}, _define_property(_obj4, "BOLD" /* BOLD */, "bold"), _define_property(_obj4, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj4, "REGULAR" /* REGULAR */, "regular"), _obj4);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment4 = gql6(_templateObject5());
var EGDSStylizedText = function (param) {
  var _param_data = param.data,
    text = _param_data.text,
    weight = _param_data.weight,
    theme = _param_data.theme,
    size = param.size,
    inline = param.inline;
  var themeProps = theme ? textThemeMapper[theme] : void 0;
  var weightProps = weight ? textWeightMapper[weight] : void 0;
  return /* @__PURE__ */React3.createElement(UitkText, {
    weight: weightProps,
    size: size,
    inline: inline,
    theme: themeProps
  }, text);
};
EGDSStylizedText.fragment = fragment4;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment5 = gql7(_templateObject6(), EGDSStylizedText.fragment, EGDSStandardLink.fragment);
var EGDSText = function (param) {
  var data = param.data,
    size = param.size,
    inline = param.inline,
    className = param.className;
  switch (data.__typename) {
    case "EGDSStylizedText":
      return /* @__PURE__ */React4.createElement(EGDSStylizedText, {
        data: data,
        size: size,
        inline: inline
      });
    case "EGDSStandardLink":
      return /* @__PURE__ */React4.createElement(EGDSStandardLink, {
        className: className,
        data: data,
        inline: inline
      });
    default:
      return null;
  }
};
EGDSText.fragment = fragment5;
EGDSText.displayName = "EGDSText";
// src/components/mre-banner/__private/components/__fragments/mre-banner-view.tsx
import React5 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSCard, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSFigure, EGDSImage } from "@egds/react-core/images";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/components/utils/clickstream.ts
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
// src/components/utils/clickstream-constants.ts
var PRESENTED_EVENT_CONSTANTS = {
  event_name: "presented" /* PRESENTED */,
  event_type: "Impression" /* IMPRESSION */,
  event_version: "1.0.0"
};
var IMPRESSION_EVENT_CONSTANTS = {
  event_name: "selected" /* SELECTED */,
  event_type: "Interaction" /* INTERACTION */,
  event_version: "1.0.0"
};
// src/components/utils/clickstream.ts
var buildEgClickstreamData = function (event, attributes) {
  return {
    event: _object_spread(_object_spread_props(_object_spread({}, event), {
      event_name: "".concat(attributes.eventNamePrefix, ".").concat(event.event_name)
    }), attributes.eventReason && {
      action_reason: attributes.eventReason
    }, attributes.eventLocation && {
      action_location: attributes.eventLocation
    })
  };
};
var useClickstreamEvent = function () {
  var track = useEgClickstream();
  return function (event, attributes) {
    var clickstreamEvent = buildEgClickstreamData(PRESENTED_EVENT_CONSTANTS, attributes);
    if (event === "selected" /* SELECTED */) {
      clickstreamEvent = buildEgClickstreamData(IMPRESSION_EVENT_CONSTANTS, attributes);
    }
    track(clickstreamEvent);
  };
};
// src/components/mre-banner/__private/components/__fragments/mre-banner-view.tsx
var mreBannerViewFragment = gql8(_templateObject7(), EGDSStylizedText.fragment, EGDSStandardLink.fragment, EGDSButton.fragment, fragment);
var MreBannerView = function (param) {
  var data = param.data;
  var _data_inLineLink, _data_button;
  var publishClickStreamEvent = useClickstreamEvent();
  var linkAnalytics = (_data_inLineLink = data.inLineLink) === null || _data_inLineLink === void 0 ? void 0 : _data_inLineLink.action.analytics;
  var buttonAnalytics = (_data_button = data.button) === null || _data_button === void 0 ? void 0 : _data_button.analytics;
  React5.useEffect(function () {
    publishClickStreamEvent("presented" /* PRESENTED */, {
      eventNamePrefix: "partner_messaging_banner" /* BANNER_PRESENTED */
    });
  }, []);
  var onClickTracking = function (reason, location) {
    publishClickStreamEvent("selected" /* SELECTED */, {
      eventNamePrefix: "partner_messaging_custom_cta" /* CTA_SELECTED */,
      eventReason: reason,
      eventLocation: location
    });
  };
  var onBannerLinkClick = function () {
    return onClickTracking(linkAnalytics === null || linkAnalytics === void 0 ? void 0 : linkAnalytics.linkName, "bannerLink" /* BANNER_LINK */);
  };
  var onBannerButtonClick = function () {
    return onClickTracking(buttonAnalytics === null || buttonAnalytics === void 0 ? void 0 : buttonAnalytics.linkName, "bannerButton" /* BANNER_BUTTON */);
  };
  var renderMreBannerView = function (param) {
    var type = param.type;
    var _data_image, _data_image1, _data_heading, _data_body;
    return /* @__PURE__ */React5.createElement(EGDSSpacing, {
      margin: {
        inline: type === "mobile" ? "six" : "unset"
      }
    }, /* @__PURE__ */React5.createElement(EGDSCard, {
      border: true
    }, /* @__PURE__ */React5.createElement(EGDSLayoutGrid, {
      columns: type === "mobile" || !data.image ? 1 : 12,
      space: "two"
    }, data.image && /* @__PURE__ */React5.createElement(EGDSLayoutGridItem, {
      colSpan: type === "mobile" ? 12 : 3
    }, /* @__PURE__ */React5.createElement(EGDSFigure, null, "className= ", type === "mobile" ? "uitk-figure--mobile" : "uitk-figure--desktop", /* @__PURE__ */React5.createElement(EGDSImage, {
      alt: (_data_image = data.image) === null || _data_image === void 0 ? void 0 : _data_image.description,
      src: (_data_image1 = data.image) === null || _data_image1 === void 0 ? void 0 : _data_image1.url,
      placeholderImage: true
    }))), /* @__PURE__ */React5.createElement(EGDSLayoutGridItem, {
      colSpan: type === "mobile" ? 12 : 9,
      alignSelf: data.image ? "center" : void 0
    }, /* @__PURE__ */React5.createElement(EGDSCardContentSection, null, /* @__PURE__ */React5.createElement(EGDSLayoutFlex, {
      direction: "column",
      alignItems: !data.image ? "center" : void 0
    }, /* @__PURE__ */React5.createElement(EGDSHeading, {
      size: 5,
      tag: "h2",
      align: data.image ? "left" : "center"
    }, (_data_heading = data.heading) === null || _data_heading === void 0 ? void 0 : _data_heading.text), /* @__PURE__ */React5.createElement(EGDSText2, {
      size: 400,
      spacing: "four",
      align: data.image ? "left" : "center"
    }, (_data_body = data.body) === null || _data_body === void 0 ? void 0 : _data_body.text, " ", data.inLineLink && /* @__PURE__ */React5.createElement(React5.Fragment, null, /* @__PURE__ */React5.createElement("span", null, " "), /* @__PURE__ */React5.createElement(EGDSLink, {
      inline: true,
      onClickCapture: onBannerLinkClick
    }, /* @__PURE__ */React5.createElement("a", {
      href: data.inLineLink.action.resource.value
    }, data.inLineLink.text))))), /* @__PURE__ */React5.createElement(EGDSSpacing, {
      margin: {
        blockstart: "four"
      }
    }, /* @__PURE__ */React5.createElement(EGDSLayoutFlex, {
      justifyContent: !data.image ? "center" : "start"
    }, /* @__PURE__ */React5.createElement(EGDSLayoutFlexItem, null, data.button && /* @__PURE__ */React5.createElement(EGDSButton, {
      data: data.button,
      onClickCapture: onBannerButtonClick
    })))))))));
  };
  return /* @__PURE__ */React5.createElement(Viewport, null, /* @__PURE__ */React5.createElement(ViewLarge, null, renderMreBannerView({
    type: "desktop"
  })), /* @__PURE__ */React5.createElement(ViewSmall, null, renderMreBannerView({
    type: "mobile"
  })));
};
MreBannerView.displayName = "MreBannerView";
MreBannerView.fragment = mreBannerViewFragment;
// src/components/mre-banner/banner.tsx
var __Query = gql9(_templateObject8(), EGDSStylizedText.fragment, EGDSStandardLink.fragment, fragment, EGDSButton.fragment);
var MreBannerComponent = function (props) {
  var inputs = props.inputs,
    skipSsr = props.skipSsr;
  var context = useBexApi().context;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  if (loading || error || !(data === null || data === void 0 ? void 0 : data.mreQuery)) {
    return null;
  }
  return /* @__PURE__ */React6.createElement("div", null, /* @__PURE__ */React6.createElement(MreBannerView, {
    data: data.mreQuery
  }));
};
MreBannerComponent.displayName = "sharedui-MREBanner";
// src/components/member-message/member-message-cards.tsx
import React10 from "react";
import { gql as gql14, useQuery as useQuery2 } from "@apollo/client";
import { EGDSCard as EGDSCard2 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex2 } from "@egds/react-core/layout-flex";
import { EGDSList, EGDSListItem } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText3 } from "@egds/react-core/text";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useLoggerEvents } from "@shared-ui/logger-context";
// src/components/utils/logger-events.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var EVENTS = {
  QUERY_ERROR_GENERIC: new SystemEvent(SystemEventLevel.ERROR, "PARTNER_MEMBER_MESSAGE_CARDS_ERROR"),
  QUERY_ERROR_NO_DATA: new SystemEvent(SystemEventLevel.ERROR, "PARTNER_MEMBER_MESSAGE_CARDS_NO_DATA")
};
// src/components/member-message/__private/__fragments/member-message-graphic.tsx
import React8 from "react";
import { gql as gql11 } from "@apollo/client";
// src/components/member-message/__private/__fragments/member-message-illustration.tsx
import React7 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSIllustrations } from "@egds/react-core/illustrations";
import { EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
var __MemberMessageIllustrationFragment = gql10(_templateObject9());
var MemberMessageIllustration = function (param) {
  var data = param.data;
  if ((data === null || data === void 0 ? void 0 : data.link) === null || (data === null || data === void 0 ? void 0 : data.link) === "") {
    return null;
  }
  return /* @__PURE__ */React7.createElement(EGDSLayoutFlexItem2, {
    maxWidth: "12x"
  }, /* @__PURE__ */React7.createElement(EGDSSpacing2, {
    margin: {
      inlineend: "three"
    }
  }, /* @__PURE__ */React7.createElement(EGDSIllustrations, {
    alt: data === null || data === void 0 ? void 0 : data.description,
    url: data.link
  })));
};
MemberMessageIllustration.displayName = "MemberMessageIllustration";
MemberMessageIllustration.fragment = __MemberMessageIllustrationFragment;
// src/components/member-message/__private/__fragments/member-message-graphic.tsx
var __MemberMessageGraphicFragment = gql11(_templateObject10(), MemberMessageIllustration.fragment);
var MemberMessageGraphic = function (param) {
  var data = param.data;
  switch (data === null || data === void 0 ? void 0 : data.__typename) {
    case "Illustration":
      return /* @__PURE__ */React8.createElement(MemberMessageIllustration, {
        data: data
      });
    default:
      return null;
  }
};
MemberMessageGraphic.displayName = "MemberMessageGraphic";
MemberMessageGraphic.fragment = __MemberMessageGraphicFragment;
// src/components/member-message/__private/__fragments/member-message-link.tsx
import React9 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
var __MemberMessageLinkFragment = gql12(_templateObject11());
var MemberMessageLink = function (param) {
  var data = param.data;
  var _data_action, _data_action_resource, _data_action1;
  var publishClickStreamEvent = useClickstreamEvent();
  var linkAnalytics = data === null || data === void 0 ? void 0 : (_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.analytics;
  var onClickTracking = function (reason, location) {
    publishClickStreamEvent("selected" /* SELECTED */, {
      eventNamePrefix: "partner_messaging_custom_cta" /* CTA_SELECTED */,
      eventReason: reason,
      eventLocation: location
    });
  };
  var onLinkClick = function () {
    return onClickTracking(linkAnalytics === null || linkAnalytics === void 0 ? void 0 : linkAnalytics.linkName, "messageCardsLink" /* MESSAGE_CARDS */);
  };
  if (!data || !(data === null || data === void 0 ? void 0 : (_data_action1 = data.action) === null || _data_action1 === void 0 ? void 0 : (_data_action_resource = _data_action1.resource) === null || _data_action_resource === void 0 ? void 0 : _data_action_resource.value)) {
    return null;
  }
  return /* @__PURE__ */React9.createElement(EGDSLink2, {
    align: "left",
    size: "medium",
    onClickCapture: onLinkClick
  }, /* @__PURE__ */React9.createElement("a", {
    href: data === null || data === void 0 ? void 0 : data.action.resource.value,
    target: data === null || data === void 0 ? void 0 : data.action.target,
    rel: "noopener",
    "aria-label": (data === null || data === void 0 ? void 0 : data.text) || ""
  }, (data === null || data === void 0 ? void 0 : data.text) || (data === null || data === void 0 ? void 0 : data.action.resource.value)));
};
MemberMessageLink.fragment = __MemberMessageLinkFragment;
MemberMessageLink.displayName = "MemberMessageLink";
// src/components/member-message/__private/__fragments/member-message-text-fragment.ts
import { gql as gql13 } from "@apollo/client";
var __MemberMessageTextFragment = gql13(_templateObject12());
var member_message_text_fragment_default = __MemberMessageTextFragment;
// src/components/member-message/member-message-cards.tsx
var __MemberMessageCardsQuery = gql14(_templateObject13(), MemberMessageGraphic.fragment, MemberMessageLink.fragment, member_message_text_fragment_default);
var PartnerMemberMessageCards = function (props) {
  var inputs = props.inputs,
    _props_skipSsr = props.skipSsr,
    skipSsr = _props_skipSsr === void 0 ? true : _props_skipSsr;
  var context = useBexApi2().context;
  var logger = useLoggerEvents(EVENTS);
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery2 = useQuery2(__MemberMessageCardsQuery, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery2.data,
    error = _useQuery2.error;
  if (error || !(data === null || data === void 0 ? void 0 : data.memberMessageCards) || (data === null || data === void 0 ? void 0 : data.memberMessageCards.length) === 0) {
    if (error) {
      logger.QUERY_ERROR_GENERIC.log({
        success: false,
        error: error
      });
    } else {
      logger.QUERY_ERROR_NO_DATA.log({
        success: false,
        error: new Error("No data while loading partner member message cards")
      });
    }
    return null;
  }
  var memberMessageCards = data.memberMessageCards;
  return /* @__PURE__ */React10.createElement(EGDSLayoutFlex2, {
    direction: "column",
    space: "four",
    "data-stid": "member-message-cards-flex-wrapper"
  }, memberMessageCards.map(function (card, index) {
    var _card_subHeading, _card_heading, _card_heading1, _card_heading2, _card_subHeading1, _card_links, _card_links1;
    return card && (((_card_subHeading = card.subHeading) === null || _card_subHeading === void 0 ? void 0 : _card_subHeading.text) || ((_card_heading = card.heading) === null || _card_heading === void 0 ? void 0 : _card_heading.text)) ? /* @__PURE__ */React10.createElement(EGDSCard2, {
      border: true,
      padded: true,
      key: "partner-messaging-card-".concat(index),
      "data-contentId": card.contentId
    }, /* @__PURE__ */React10.createElement(EGDSSpacing3, {
      padding: "two"
    }, /* @__PURE__ */React10.createElement(EGDSLayoutFlex2, {
      alignItems: "center",
      "data-stid": "member-message-card-content",
      "data-contentId": card.contentId
    }, card.graphic && /* @__PURE__ */React10.createElement(MemberMessageGraphic, {
      data: card.graphic
    }), (card.heading || card.subHeading) && /* @__PURE__ */React10.createElement(EGDSLayoutFlex2, {
      direction: "column"
    }, /* @__PURE__ */React10.createElement(EGDSSpacing3, {
      padding: {
        inlineend: "two"
      }
    }, /* @__PURE__ */React10.createElement(React10.Fragment, null, ((_card_heading1 = card.heading) === null || _card_heading1 === void 0 ? void 0 : _card_heading1.text) && /* @__PURE__ */React10.createElement(EGDSHeading2, {
      "aria-label": card.heading.text
    }, " ", (_card_heading2 = card.heading) === null || _card_heading2 === void 0 ? void 0 : _card_heading2.text), ((_card_subHeading1 = card.subHeading) === null || _card_subHeading1 === void 0 ? void 0 : _card_subHeading1.text) && /* @__PURE__ */React10.createElement(EGDSSpacing3, {
      margin: {
        blockstart: "half"
      }
    }, /* @__PURE__ */React10.createElement(EGDSText3, {
      theme: "default",
      "aria-label": card.subHeading.text
    }, card.subHeading.text)), card.links && (card === null || card === void 0 ? void 0 : (_card_links = card.links) === null || _card_links === void 0 ? void 0 : _card_links.length) > 0 && /* @__PURE__ */React10.createElement(EGDSList, {
      bullet: "no-bullet",
      orientation: "inline"
    }, card === null || card === void 0 ? void 0 : (_card_links1 = card.links) === null || _card_links1 === void 0 ? void 0 : _card_links1.map(function (link, linkIndex) {
      return link ? /* @__PURE__ */React10.createElement(EGDSListItem, {
        key: "partner-messaging-card-link-".concat(linkIndex)
      }, /* @__PURE__ */React10.createElement(MemberMessageLink, {
        data: link
      })) : null;
    })))))))) : null;
  }));
};
PartnerMemberMessageCards.displayName = "sharedui-PartnerMemberMessageCards";
export { MreBannerComponent, PartnerMemberMessageCards };